__turbopack_context__.v({
  "awards": "awards-module-scss-module__jqjNAa__awards",
  "awardsWrp": "awards-module-scss-module__jqjNAa__awardsWrp",
});
